import { isAddToCartPayload } from '../../../shoppable/types';
import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';
import { InternalAddToCartPayload } from './types';

export const internalAddToCartPayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.AddToCart
> = (payload: unknown): payload is InternalAddToCartPayload =>
  isAddToCartPayload(payload);
